/**
 * Shared deactivation/deletion mode constants
 * Used by both equipment and crew member deactivation flows
 */
export const DEACTIVATE_DELETE_MODES = {
  NO_EXPERIENCES: "no_experiences",
  ASSIGNED_EXPERIENCES_NO_ACTIVE_BOOKING: "assigned_experiences_no_active_booking",
  FULLY_SUBSTITUTABLE: "fully",
  PARTIALLY_SUBSTITUTABLE: "partially"
}

/**
 * Resource types that can be deactivated/deleted
 */
export const RESOURCE_TYPES = {
  EQUIPMENT: "equipment",
  CREW: "crew"
}
